export default __webpack_public_path__ + "static/media/gke.75925e5e.svg";